<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <h6>Lista de operaciones</h6>

            <!-- se agg una row mas para la busqueda-->
            <div class="row">

              <!-- Columna de búsqueda -->
              <div class="col-md-5 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar..." @input="handleSearchInput" />
              </div>


              <div class="col-md-5 mb-3">
                <label for="filterProduction" class="mb-1">Filtrar por producción</label>
                <select ref="filterProduction" class="form-select" id="filterProduction">
                  <option value="">Seleccionar producción</option>
                  <option v-for="production in productionFilters" :key="production.id" :value="production.id">
                    #{{ production.id }} - {{ production.name || 'Sin nombre' }} ({{  production.model?.ref || 'Sin ref' }})
                  </option>
                </select>
              </div>

              <div class="col-md-2 mb-3">
                <label class="mb-1 d-block">&nbsp;</label>
                <argon-button color="info" size="sm" class="w-100 mt-2" @click="openFiltersModal">
                  <i class="fa fa-filter me-1"></i> Filtros
                </argon-button>
              </div>

              <div class="col-12 mb-3">
                <div class="operation-actions">
                  <argon-button color="info" size="sm" class="operation-action-btn" @click="downloadFilteredExcel">
                    <i class="fa fa-download me-1"></i> Descargar Excel
                  </argon-button>
                  <argon-button color="success" size="sm" class="operation-action-btn" @click="openModal">Asignar usuario</argon-button>
                </div>
              </div>

              <!-- Botones de acción masiva -->
              <div class="col-12 mb-3" v-if="selectedItems.length > 0">
                <div class="d-flex gap-2 align-items-center">
                  <span class="text-sm font-weight-bold">{{ selectedItems.length }} elemento(s) seleccionado(s)</span>
                  <argon-button 
                    v-if="canBulkMarkAsReceived"
                    color="info" 
                    size="sm" 
                    @click="bulkMarkAsReceived">
                    Marcar como Recibido
                  </argon-button>
                  <argon-button 
                    v-if="canBulkMarkAsDelivered"
                    color="warning" 
                    size="sm" 
                    @click="bulkMarkAsDelivered">
                    Marcar como Entregado
                  </argon-button>
                  <argon-button 
                    v-if="canBulkMarkAsValidated"
                    color="success" 
                    size="sm" 
                    @click="bulkMarkAsValidated">
                    Marcar como Validado
                  </argon-button>
                  <argon-button 
                    color="secondary" 
                    size="sm" 
                    @click="clearSelection">
                    Limpiar selección
                  </argon-button>
                </div>
              </div>

            </div>


          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      OPCIONES
                      <input 
                        v-if="selectableItemsCount > 0"
                        type="checkbox" 
                        @change="toggleSelectAll" 
                        :checked="isAllSelected"
                        style="margin-left: 10px;">
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producción</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Modelo</th>
                    
                     <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cant.
                        recibida</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cant.
                        entregada</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cant.
                        defectuosa</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha
                        asignado</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha
                        recibido</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha
                        entregado</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha
                        validado</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        observación</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total
                        ganancia</th>

                    <!-- <th class="text-secondary text-center">
                      <router-link :to="{ name: 'Production Create' }" class="text-secondary font-weight-bold text-xs"
                        data-toggle="tooltip" data-original-title="Agregar insumo">
                        Agregar <i class="fa fa-plus"></i>
                      </router-link>
                    </th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td class="align-middle text-center">
                        <div style="display: flex;justify-content: center; align-items: center;gap: 10px;height: 100%;">
                          <input 
                            v-if="value.validated_date == null"
                            type="checkbox" 
                            :value="value.id"
                            :disabled="!canSelectItem(value)"
                            @change="handleCheckboxChange(value, $event)"
                            :checked="selectedItems.includes(value.id)">
                          <a @click="checkReceived(value)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Registro" v-if="value.received_date == null">
                            <i class="fa fa-arrow-down"></i>
                          </a>


                          <a @click="checkDelivered(value)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Eliminar registro"
                            v-if="(value.received_date != null && value.delivered_date == null)">
                            <i class="fa fa-arrow-up"></i>
                          </a>

                          <a @click="checkValidated(value)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Validar tarea"
                            v-if="value.delivered_date != null && value.validated_date == null">
                            <i class="fa fa-check"></i>
                          </a>
                          <a @click="addDefectuososAndCreateTask(value)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Asignar arreglos"
                            v-if="value.validated_date != null">
                            <i class="fa fa-clipboard-check"></i>
                          </a>

                          <span style="color: forestgreen;" v-if="value.validated_date != null">
                            <i class="fa fa-check"></i>
                          </span>

                          <a
                            @click="generatePdf(value.id)"
                            class="text-danger font-weight-bold text-xs cursor-pointer"
                            data-toggle="tooltip"
                            data-original-title="Generar PDF"
                          >
                            <i class="fa fa-file-pdf"></i>
                          </a>

                    
                          <a @click="deleteUserRegister(value.id)" 
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Eliminar registro" v-if="value?.production?.status != null && value.production.status < 2 && value.validated_date == null ">
                            <i class="fa fa-trash"></i>
                          </a>
                        </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <div class="d-flex">
                          <router-link
                            v-if="value.production"
                            :to="{ name: 'Production Create', query: { id: value.production.id } }"
                            class="text-secondary font-weight-bold text-xs"
                            data-toggle="tooltip"
                            data-original-title="Editar Registro"
                          >
                            <h6 class="mb-0 text-sm">{{ value?.user?.name }} </h6>
                          </router-link>
                          <span v-else class="text-secondary font-weight-bold text-xs">
                            <h6 class="mb-0 text-sm">{{ value?.user?.name }} </h6>
                          </span>
                              <a
                              @click="editModal(value)" 
                              class="text-secondary font-weight-bold text-xs cursor-pointer mx-2"
                              data-toggle="tooltip"
                              data-original-title="Editar registro" 
                              v-if="value.validated_date==null"
                            >
                              <i class="fa fa-pencil-alt"></i>
                            </a>
                            </div>
                           
                            <span class="badge badge-sm"
                              :class="value.user?.payment === 0 ? 'bg-gradient-info' : 'bg-gradient-success'">
                              {{ value.user?.payment === 0 ? 'Mensualidad' : 'Tarea' }}
                            </span>
                        
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm" v-if="value.production">
                              #{{ value.production.id || '-' }} - {{ value.production.name || 'Sin nombre' }}
                            </h6>
                            <h6 class="mb-0 text-sm" v-else>
                              {{ value.description || 'Tarea flotante' }}
                            </h6>
                        </div>
                      </div>
                    </td>
                     <td class="align-middle">
                        <div class="text-secondary text-xs font-weight-bold">
                          Modelo: {{ value?.model?.model?.name }}
                        </div>
                        <div class="text-secondary text-xs font-weight-bold">
                          Oficio: {{ value?.oficio?.name }}
                        </div>
                        <div class="text-secondary text-xs font-weight-bold">
                          Talla: {{ value?.model?.size?.size ?? "Full" }}
                        </div>
                        <div class="text-secondary text-xs font-weight-bold">
                          Color: {{ value?.model?.size?.color?.name ?? "Full" }}
                        </div>
                      </td>
                    
                      <td class="align-middle text-center">
                        <template v-if="value.received_date == null">
                          <input
                            type="text"
                            class="form-control form-control-sm text-center"
                            v-model.number="value.received_quantity"
                            @blur="handleDeliveredQuantityChange(value)"
                            placeholder="Ingresar cantidad"
                            style="max-width: 100px; margin: 0 auto;"
                          />
                        </template>
                        <template v-else>
                          <label>{{ value.received_quantity }}</label>
                        </template>
                      </td>

                      <td class="align-middle text-center">
                        <template v-if="value.received_date != null && value.delivered_date == null">
                          <input
                            type="number"
                            class="form-control form-control-sm text-center"
                            v-model.number="value.delivered_quantity"
                            @blur="handleDeliveredInput(value)"
                            :max="value.received_quantity"
                            min="0"
                            step="1"
                            placeholder="Ingresar"
                            style="max-width: 100px; margin: 0 auto;"
                          />
                        </template>
                        <template v-else>
                          {{ value.delivered_quantity }}
                        </template>
                      </td>
                      <td class="align-middle text-center">
                        {{ value.rejected_quantity }}
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ isValidDate(value.assigned_at) ? new Date(value.assigned_at).toLocaleDateString('es-ES') :
                            'Sin asignar' }}
                        </span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ isValidDate(value.received_date) ? new
                            Date(value.received_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                        </span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ isValidDate(value.delivered_date) ? new
                            Date(value.delivered_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                        </span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ isValidDate(value.validated_date) ? new
                            Date(value.validated_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                        </span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          <a @click="viewObservation(value.observation,value.laundry_observation)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Registro">
                            <i class="fa fa-comment"></i>
                          </a>
                        </span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.total).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) }}
                        </span>
                      </td>

                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="12" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>

                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  
    <!-- Modal Filtros -->
    <div class="modal fade" id="ModalFilters" tabindex="-1" aria-labelledby="filtersModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="filtersModalLabel">Filtros</h5>
            <button type="button" class="btn-close" @click="closeFiltersModal"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="filterOficioModalSelect" class="mb-1">Filtrar por oficio</label>
              <select v-model="filterOficioModal" class="form-select" id="filterOficioModalSelect">
                <option value="">Seleccionar</option>
                <option v-for="value in oficios" :key="value.id" :value="value.id">{{ value.name }}</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="filterPaymentModal" class="mb-1">Filtrar por pago</label>
              <select v-model="filterPayment" class="form-select" id="filterPaymentModal">
                <option value="">Seleccionar</option>
                <option value="0">Mensualidad</option>
                <option value="1">Tarea</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="startDateModal" class="mb-1">Desde</label>
              <input type="date" v-model="startDate" id="startDateModal" class="form-control" />
            </div>
            <div class="mb-3">
              <label for="endDateModal" class="mb-1">Hasta</label>
              <input type="date" v-model="endDate" id="endDateModal" class="form-control" />
            </div>
            <div class="mb-3">
              <label for="filterStatusModal" class="mb-1">Filtrar por estado</label>
              <select v-model="filterStatus" class="form-select" id="filterStatusModal">
                <option value="">Seleccionar</option>
                <option value="not_received">Sin recibir</option>
                <option value="not_delivered">Sin entregar</option>
                <option value="not_validated">Sin validar</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="clearFilters">Limpiar</button>
            <button type="button" class="btn btn-primary" @click="applyFilters">Aplicar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Asignar tecnico -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Asignar usuario
              <span v-if="loadingProductions" class="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

               <div class="mb-3">
                <label for="amount" class="form-label">Producción</label>
                <select ref="productionSelect"  class="form-select select2"
                  style="width:100%;">
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Modelo</label>
                <select ref="modelSelect"  class="form-select select2"
                  style="width:100%;">
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Oficio</label>
                <select  ref="oficiosSelect" id="oficio" class="form-select select2"
                  style="width:100%;">
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Usuario</label>
                <select ref="usersSelect" id="users" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Cantidad asignada</label>
                <input 
                  type="number" 
                  v-model.number="production_user.received_quantity" 
                  id="amount" 
                  class="form-control"
                  placeholder="Ingrese el valor"
                  :max="maxQuantityAllowed"
                  min="0"
                  step="1"
                  @input="validateQuantity"
                >
                <small class="text-muted" v-if="maxQuantityAllowed > 0">
                  Máximo permitido: {{ maxQuantityAllowed }}
                </small>
              </div>

              <div class="mb-3" v-if="fieldPayment">
                <label for="amount" class="form-label">Valor a pagar por unidad</label>
                <input type="text" v-model="formattedTotalUser" class="form-control" placeholder="Ingrese el valor">
              </div>

              <div class="mb-3" v-if="fieldPayment">
                <label for="amount" class="form-label">Valor total</label>
                <input type="text" v-model="totalPriceUser" class="form-control" placeholder="Ingrese el valor"
                  readonly>
              </div>

              <div class="mb-3" v-if="fieldPayment && benefitsOfTasks">
                <label for="benefit" class="form-label">Valor del beneficio por tarea</label>
                <input type="text" v-model="formattedBenefit" class="form-control" placeholder="Ingrese el valor del beneficio">
              </div>

              <div class="mb-3">
                <label for="example-text-input" class="form-control-label">Fecha de asignación</label>
                <argon-input type="date" v-model="production_user.assigned_at" />
              </div>

              <div class="mb-3 d-flex align-items-center gap-2">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="markAsReceived"
                    v-model="markAsReceived"
                  />
                  <label class="form-check-label" for="markAsReceived">Marcar tarea como recibida</label>
                </div>
                <a
                  @click="openValidarTareaFromModal"
                  class="text-secondary font-weight-bold text-xs cursor-pointer"
                  data-toggle="tooltip"
                  data-original-title="Asignar arreglos"
                  title="Asignar arreglos">
                  <i class="fa fa-clipboard-check"></i>
                </a>
              </div>

               <div class="mb-3">
                <label for="example-text-input" class="form-control-label">Última asignación</label><br>
                <label for="example-text-input" class="form-control-label" id="mensajeAsignacion">Sin asignar</label>
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" id="ModalEditStaff" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content card">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Editar usuario</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>

            <div class="mb-3">
              <label class="form-label">Usuario</label>
              <select ref="userSelect" id="staffEdit" class="form-select select2" style="width:100%;" >
                <option v-for="process in users" :key="process.id" :value="process.id">
                  {{ process.name }} 
                </option>
              </select>
            </div>

          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeEditModal">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="submitEditForm">Guardar</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import ArgonButton from "../../../components/ArgonButton.vue";
import ArgonInput from "../../../components/ArgonInput.vue";
import axios from 'axios';

import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';
import Swal from 'sweetalert2';
export default {
  name: 'ProjectsTable',
  data() {
    return {
      modalEdit:null,
      filterModal: null,
      searchQuery: '', // Para el campo de búsqueda
      startDate: '',   // Para la fecha de inicio
      endDate: '',     // Para la fecha de fin
      filterPayment: '',
      filterStatus: '',
      filterOficioModal: '',
      loadingProductions: false,
      modalBudget: null,
      cancelTokenSource: null, // Para cancelar peticiones anteriores
      searchTimeout: null, // Para el debounce de la búsqueda
      production_user: {
        id: 0,
        user_id: 0,
        production_models_id: 0,
        oficio_id: 0,
        production_id: 0,
        received_quantity: 0,
        delivered_quantity: 0,
        price: 0,
        benefit: 0,
        assigned_at: '',
      },
      benefitsOfTasks: false,
      productions:[],
      models:[],
      users:[],
      filteredUsers:[],
      oficios: [],
      selectedProductionFilter: '',
      productionFilters: [],
      fieldPayment: false,
      page: 1,
      selectedItems: [], // Array para almacenar los IDs seleccionados
      markAsReceived: false,
      isSaving: false, // Flag para evitar envíos duplicados
    };
  },
  components: { ArgonInput,ArgonButton },
  computed: {
    ...mapGetters('productionUsers', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
    currentPage() {
      return this.$store.state.productionUsers.currentPage; // Obtiene la página actual
    },
    lastPage() {
      return this.$store.state.productionUsers.lastPage; // Obtiene la última página
    },
    data() {
      return this.allData; // Retorna los usuarios desde el store
    },
    links() {
      return this.$store.getters['productionUsers/links']; // Retorna los links
    },
    totalPriceUser() {
      // Calcula el total y aplica el formateo
      const total = this.production_user.received_quantity * this.production_user.price;
      return total
        ? total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        : "0";
    },
    formattedTotalUser: {
      get() {
        // Formatea el precio a punto de mil y sin decimales
        return Math.floor(this.production_user.price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el precio sin decimales
        this.production_user.price = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    formattedBenefit: {
      get() {
        // Formatea el beneficio a punto de mil y sin decimales
        return Math.floor(this.production_user.benefit || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el beneficio sin decimales
        this.production_user.benefit = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    selectableItemsCount() {
      // Contar solo los items que no están validados
      return this.data.filter(item => item.validated_date == null).length;
    },
    isAllSelected() {
      // Verificar si todos los items seleccionables están seleccionados
      const selectableItems = this.data.filter(item => item.validated_date == null);
      if (selectableItems.length === 0) {
        return false;
      }
      // Si hay items seleccionados, verificar que todos los del mismo estado estén seleccionados
      if (this.selectedItems.length === 0) {
        return false;
      }
      const state = this.selectedItemsState;
      if (!state) {
        return false;
      }
      const itemsOfSameState = selectableItems.filter(item => this.getItemState(item) === state);
      return itemsOfSameState.length > 0 && itemsOfSameState.every(item => this.selectedItems.includes(item.id));
    },
    canBulkMarkAsReceived() {
      // Solo puede marcar como recibido si hay items seleccionados que no tienen received_date
      return this.selectedItems.length > 0 && this.data.some(item => 
        this.selectedItems.includes(item.id) && item.received_date == null
      );
    },
    canBulkMarkAsDelivered() {
      // Solo puede marcar como entregado si hay items seleccionados que tienen received_date pero no delivered_date
      return this.selectedItems.length > 0 && this.data.some(item => 
        this.selectedItems.includes(item.id) && item.received_date != null && item.delivered_date == null
      );
    },
    canBulkMarkAsValidated() {
      // Solo puede marcar como validado si hay items seleccionados que tienen delivered_date pero no validated_date
      return this.selectedItems.length > 0 && this.data.some(item => 
        this.selectedItems.includes(item.id) && item.delivered_date != null && item.validated_date == null
      );
    },
    selectedItemsState() {
      // Obtener el estado del primer elemento seleccionado
      if (this.selectedItems.length === 0) {
        return null;
      }
      const firstSelected = this.data.find(item => this.selectedItems.includes(item.id));
      if (!firstSelected) {
        return null;
      }
      return this.getItemState(firstSelected);
    },
    maxQuantityAllowed() {
      // Calcular la cantidad máxima permitida según el modelo seleccionado
      if (!this.$refs.modelSelect || !this.models || this.models.length === 0) {
        return 0;
      }
      
      try {
        const val = $(this.$refs.modelSelect).val();
        let maxCant = 0;
        
        if (parseInt(val) === 0 || val === '0' || val === null) {
          // Producción completa: suma de todas las cantidades
          maxCant = this.models.reduce((acc, item) => acc + (parseFloat(item.quantity_to_produce) || 0), 0);
        } else {
          // Modelo específico seleccionado
          const selected = this.models.find(model => model.id === parseInt(val));
          maxCant = selected ? (parseFloat(selected.quantity_to_produce) || 0) : 0;
        }
        
        // Si hay un oficio seleccionado, considerar la cantidad pendiente del oficio
        // La cantidad máxima será el mínimo entre la cantidad del modelo y la cantidad pendiente del oficio
        if (this.$refs.oficiosSelect) {
          const selectedOption = $(this.$refs.oficiosSelect).find('option:selected');
          const pendingQuantity = selectedOption.data('quantity');
          
          if (pendingQuantity) {
            const pendingQty = parseFloat(pendingQuantity) || 0;
            // Tomar el mínimo entre la cantidad del modelo y la cantidad pendiente del oficio
            maxCant = Math.min(maxCant, pendingQty);
          }
        }
        
        return maxCant;
      } catch (error) {
        console.error('Error calculando cantidad máxima:', error);
        return 0;
      }
    },
  },
  watch: {
    'production_user.received_quantity': function (newVal) {
      // Validar que la cantidad asignada no exceda el máximo permitido
      const maxAllowed = this.maxQuantityAllowed;
      const currentQuantity = parseFloat(newVal) || 0;
      
      if (maxAllowed > 0 && currentQuantity > maxAllowed) {
        this.production_user.received_quantity = maxAllowed;
      }
      
      // También validar que no sea negativa
      if (currentQuantity < 0) {
        this.production_user.received_quantity = 0;
      }
    },
    'production_user.oficio_id': function () {
      // Cuando se selecciona un oficio, establecer la cantidad asignada a la cantidad pendiente
      if (this.$refs.oficiosSelect) {
        const selectedOption = $(this.$refs.oficiosSelect).find('option:selected');
        const pendingQuantity = selectedOption.data('quantity');
        
        if (pendingQuantity) {
          this.production_user.received_quantity = parseFloat(pendingQuantity) || 0;
        }
      }
    },
  },
  methods: {
    openFiltersModal() {
      const modalElement = document.getElementById('ModalFilters');
      this.filterModal = new Modal(modalElement);
      this.filterModal.show();
    },
    closeFiltersModal() {
      if (this.filterModal) {
        this.filterModal.hide();
      }
    },
    applyFilters() {
      this.page = 1;
      this.fetchData(null);
      this.closeFiltersModal();
    },
    clearFilters() {
      this.filterPayment = '';
      this.filterStatus = '';
      this.filterOficioModal = '';
      this.startDate = '';
      this.endDate = '';
      this.page = 1;
      this.fetchData(null);
    },
    async downloadFilteredExcel() {
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');

        const filters = {
          search: this.searchQuery || '',
          start_date: this.startDate || '',
          end_date: this.endDate || '',
          production: this.selectedProductionFilter || '',
          oficio: this.filterOficioModal || '',
          payment: this.filterPayment !== '' ? this.filterPayment : '',
          user_id: user && user.role === '3' ? user.id : '',
        };

        const response = await this.$store.dispatch('analitycs/getReportProductionUser', filters);
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'operaciones_filtradas.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al descargar excel filtrado:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo descargar el Excel de operaciones filtradas.',
        });
      }
    },
    async generatePdf(id) {
      try {
        const response = await this.$store.dispatch("productionUsers/getPdf", id);

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `formato_entrega_corte_${id}.pdf`);
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: 'El PDF se ha generado correctamente.',
          timer: 2000,
          showConfirmButton: false
        });
      } catch (error) {
        console.error("Error al generar el PDF:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'Error al generar el PDF',
        });
      }
    },
    validateQuantity() {
      // Validar que la cantidad asignada no exceda el máximo permitido
      if (!this.$refs.oficiosSelect) {
        return;
      }
      
      const maxAllowed = this.maxQuantityAllowed;
      const currentQuantity = parseFloat(this.production_user.received_quantity) || 0;
      
      if (maxAllowed > 0 && currentQuantity > maxAllowed) {
        this.production_user.received_quantity = maxAllowed;
      }
      
      // También validar que no sea negativa
      if (currentQuantity < 0) {
        this.production_user.received_quantity = 0;
      }
    },
    getItemState(item) {
      // Determinar el estado del registro: 'receive', 'deliver', 'validate', 'validated'
      if (item.validated_date != null) {
        return 'validated';
      }
      if (item.delivered_date != null && item.validated_date == null) {
        return 'validate';
      }
      if (item.received_date != null && item.delivered_date == null) {
        return 'deliver';
      }
      if (item.received_date == null) {
        return 'receive';
      }
      return null;
    },
    canSelectItem(item) {
      // Si no hay items seleccionados, permitir seleccionar
      if (this.selectedItems.length === 0) {
        return true;
      }
      // Si el item ya está validado, no se puede seleccionar
      if (item.validated_date != null) {
        return false;
      }
      // Verificar que el estado del item coincida con el estado de los items seleccionados
      const itemState = this.getItemState(item);
      return itemState === this.selectedItemsState;
    },
    handleCheckboxChange(item, event) {
      const isChecked = event.target.checked;
      const itemState = this.getItemState(item);
      
      // Si el item está validado, no permitir seleccionar
      if (item.validated_date != null) {
        event.target.checked = false;
        return;
      }
      
      if (isChecked) {
        // Si es el primer item seleccionado, agregarlo
        if (this.selectedItems.length === 0) {
          this.selectedItems.push(item.id);
        } else {
          // Obtener el estado del primer item seleccionado
          const firstSelected = this.data.find(i => this.selectedItems.includes(i.id));
          const firstSelectedState = firstSelected ? this.getItemState(firstSelected) : null;
          
          // Verificar que el estado coincida
          if (itemState === firstSelectedState) {
            this.selectedItems.push(item.id);
          } else {
            // Si no coincide, mostrar mensaje y no seleccionar
            event.target.checked = false;
            Swal.fire({
              icon: 'warning',
              title: 'Atención',
              text: 'Solo puede seleccionar registros del mismo estado. Deseleccione los actuales para seleccionar otros.',
              timer: 2000,
              showConfirmButton: false,
            });
          }
        }
      } else {
        // Deseleccionar
        const index = this.selectedItems.indexOf(item.id);
        if (index > -1) {
          this.selectedItems.splice(index, 1);
        }
      }
    },
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedItems = [];
      } else {
        // Solo seleccionar los items que no estén validados y que coincidan con el estado del primer item seleccionado
        if (this.selectedItems.length === 0) {
          // Si no hay nada seleccionado, seleccionar todos los que pueden recibir tarea
          this.selectedItems = this.data
            .filter(item => item.validated_date == null && item.received_date == null)
            .map(item => item.id);
        } else {
          // Si ya hay algo seleccionado, seleccionar todos los del mismo estado
          const state = this.selectedItemsState;
          if (state) {
            this.selectedItems = this.data
              .filter(item => this.getItemState(item) === state)
              .map(item => item.id);
          }
        }
      }
    },
    clearSelection() {
      this.selectedItems = [];
    },
    async bulkMarkAsReceived() {
      if (this.selectedItems.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe seleccionar al menos un registro.',
        });
        return;
      }

      // Filtrar solo los que pueden ser marcados como recibidos
      const validIds = this.data
        .filter(item => this.selectedItems.includes(item.id) && item.received_date == null)
        .map(item => item.id);

      if (validIds.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Los registros seleccionados ya están marcados como recibidos o no pueden ser marcados.',
        });
        return;
      }

      try {
        const result = await Swal.fire({
          title: 'Marcar como Recibido',
          text: `¿Está seguro de marcar ${validIds.length} registro(s) como recibido(s)?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, marcar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionUsers/bulkMarkAsReceived", validIds);
          
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: response.data.message || 'Registros marcados como recibidos correctamente.',
            });
            this.clearSelection();
            this.fetchData();
          } else {
            throw new Error(response.data?.message || 'Error al marcar los registros');
          }
        }
      } catch (error) {
        console.error("Error al marcar como recibido:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al marcar los registros como recibidos',
        });
      }
    },
    async bulkMarkAsDelivered() {
      if (this.selectedItems.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe seleccionar al menos un registro.',
        });
        return;
      }

      // Filtrar solo los que pueden ser marcados como entregados
      const validIds = this.data
        .filter(item => this.selectedItems.includes(item.id) && item.received_date != null && item.delivered_date == null)
        .map(item => item.id);

      if (validIds.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Los registros seleccionados ya están marcados como entregados o no pueden ser marcados.',
        });
        return;
      }

      try {
        const result = await Swal.fire({
          title: 'Marcar como Entregado',
          text: `¿Está seguro de marcar ${validIds.length} registro(s) como entregado(s)?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, marcar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionUsers/bulkMarkAsDelivered", validIds);
          
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: response.data.message || 'Registros marcados como entregados correctamente.',
            });
            this.clearSelection();
            this.fetchData();
          } else {
            throw new Error(response.data?.message || 'Error al marcar los registros');
          }
        }
      } catch (error) {
        console.error("Error al marcar como entregado:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al marcar los registros como entregados',
        });
      }
    },
    async bulkMarkAsValidated() {
      if (this.selectedItems.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe seleccionar al menos un registro.',
        });
        return;
      }

      // Filtrar solo los que pueden ser marcados como validados
      const validIds = this.data
        .filter(item => this.selectedItems.includes(item.id) && item.delivered_date != null && item.validated_date == null)
        .map(item => item.id);

      if (validIds.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Los registros seleccionados ya están marcados como validados o no pueden ser marcados.',
        });
        return;
      }

      try {
        const result = await Swal.fire({
          title: 'Marcar como Validado',
          text: `¿Está seguro de marcar ${validIds.length} registro(s) como validado(s)?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, marcar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionUsers/bulkMarkAsValidated", validIds);
          
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: response.data.message || 'Registros marcados como validados correctamente.',
            });
            this.clearSelection();
            this.fetchData();
          } else {
            throw new Error(response.data?.message || 'Error al marcar los registros');
          }
        }
      } catch (error) {
        console.error("Error al marcar como validado:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al marcar los registros como validados',
        });
      }
    },
    editModal(detail) {
      this.production_user = detail;

      $('#staffEdit').val(detail.user_id).trigger('change');
      const modalElement = document.getElementById('ModalEditStaff');
      this.modalEdit = new Modal(modalElement); // Guarda la instancia del modal
      this.modalEdit.show(); // Muestra el modal
    },
    closeEditModal() {
      if (this.modalEdit) {
        this.modalEdit.hide(); // Cierra el modal
      }
    },
    handleDeliveredQuantityChange(detail) {
      if (this.isSaving) return;
      this.production_user = detail;
      this.submitEditForm();
    },
    async submitEditForm(){
      if (this.isSaving) return;
      this.isSaving = true;
      try {
        this.production_user.oficio_id = this.oficio_id;
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("productionUsers/save", this.production_user);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              $(this.$refs.userSelect).val(null).trigger('change');

              this.production_user.id=0;
              this.fetchData();
              this.closeEditModal();
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      } finally {
        this.isSaving = false;
      }
    },
    viewObservation(observation, laundry_observation) {
      // Construir el contenido en HTML
      let htmlMessage = '';

      if (observation) {
        htmlMessage += `<h3 style="margin-bottom: 5px;">Observación</h3><p>${observation}</p>`;
      } else {
        htmlMessage += `<h3 style="margin-bottom: 5px;">Observación</h3><p>No hay observaciones disponibles.</p>`;
      }

      if (laundry_observation) {
        htmlMessage += `<h3 style="margin-top: 15px; margin-bottom: 5px;">Observación Adicional</h3><p>${laundry_observation}</p>`;
      }

      // Mostramos el mensaje en un SweetAlert
      Swal.fire({
        title: '', // Dejamos el título vacío porque usamos h3 en html
        html: htmlMessage,
        icon: 'info',
        confirmButtonText: 'Aceptar'
      });
    },

    async getProductions() {
      this.loadingProductions = true;
      const productions = await this.$store.dispatch('production/getAll');

      console.log(productions);
      this.productions = productions.filter(h => h.status==1);

          // Limpia el select antes de cargar
      $(this.$refs.productionSelect).empty();

      // Agrega placeholder vacío
      $(this.$refs.productionSelect).append(
        $('<option>', { value: '', text: 'Seleccione una producción' })
      );

      // Recorre las producciones y las agrega
      this.productions.forEach(p => {
        // Formatear la fecha de entrega si existe
        const deliveryDate = p.delivery_date 
          ? new Date(p.delivery_date).toLocaleDateString('es-ES')
          : 'Sin fecha';
        
        // Crear el texto del option similar al formato de Modelos en production/Create.vue
        const optionText = `Producción: #${p.id} - ${p.name || 'Sin nombre'} - Fecha entrega: ${deliveryDate}`;
        
        $(this.$refs.productionSelect).append(
          $('<option>', { value: p.id, text: optionText })
        );
      });

      $(this.$refs.productionSelect).select2({
        placeholder: 'Seleccione una producción',
        allowClear: false,
        dropdownParent: $('#ModalBudget .modal-body'),
      }).on('change', () => {
        this.production_user.production_id = $(this.$refs.productionSelect).val();
        this.getModels();
        this.getOficios();
      });
      this.loadingProductions = false;
    },
    async getProductionFilterList() {
      const productions = await this.$store.dispatch('production/getAll');
      this.productionFilters = Array.isArray(productions) ? productions : [];
    },
    initProductionFilterSelect2() {
      if (!this.$refs.filterProduction) return;

      if ($(this.$refs.filterProduction).hasClass('select2-hidden-accessible')) {
        $(this.$refs.filterProduction).off('change').select2('destroy');
      }

      $(this.$refs.filterProduction).select2({
        placeholder: 'Seleccionar producción',
        allowClear: true,
        width: '100%',
      }).on('change', () => {
        this.selectedProductionFilter = $(this.$refs.filterProduction).val() || '';
        this.fetchData(null);
      });

      if (this.selectedProductionFilter) {
        $(this.$refs.filterProduction).val(String(this.selectedProductionFilter)).trigger('change.select2');
      }
    },
    async getModels() {

      const models = await this.$store.dispatch('productionModels/getData', this.production_user.production_id);
      this.models = models.data;
      // Limpia el select antes de cargar
      $(this.$refs.modelSelect).empty();

      // Agrega placeholder vacío
      $(this.$refs.modelSelect).append(
        $('<option>', { value: 0, text: 'Producción completa' })
      );

      // Recorre las producciones y las agrega
      this.models.forEach(p => {
        const optionText = `Modelo: ${p?.model?.name} - Talla: ${p?.size?.size} - Color: ${p?.size?.color?.name} (${p?.size?.color?.ref}) - Cantidad: ${p?.quantity_to_produce}`;

        $(this.$refs.modelSelect).append(
          $('<option>', { value: p.id, text: optionText }).attr('data-quantity', p?.quantity_to_produce) 
        );
      });

      $(this.$refs.modelSelect).select2({
        placeholder: 'Seleccione un modelo',
        allowClear: false,
        dropdownParent: $('#ModalBudget .modal-body'),
      }).on('change', () => {
        this.production_user.production_models_id = $(this.$refs.modelSelect).val();
        
        this.$nextTick(() => {
          let modelo = this.models.find(model =>
            model.id === parseInt(this.production_user?.production_models_id)
          );

          if (parseInt(this.production_user.production_models_id) === 0) {
            // Producción completa: suma de todas las cantidades
            this.production_user.received_quantity = this.models.reduce((acc, item) => acc + (parseFloat(item.quantity_to_produce) || 0), 0);
          } else {
            // Modelo específico seleccionado
            if (modelo && modelo.quantity_to_produce) {
              this.production_user.received_quantity = parseFloat(modelo.quantity_to_produce) || 0;
            }
          }

          // Validar la cantidad después de cambiar el modelo
          this.validateQuantity();
        });
        
        this.getOficios();
      });

    },
    async getOficiosList() {
      this.oficios = await this.$store.dispatch('users/getOficios');
    },
    async getOficios(){

      let oficios = this.oficios;


      if(this.production_user.production_models_id != 0){
        
        const modelo = this.models.find(h => parseInt(h.id) == parseInt(this.production_user.production_models_id) );

        oficios = modelo?.oficios;
        
      }

      

       // Limpia el select antes de cargar
      $(this.$refs.oficiosSelect).empty();

      // Agrega placeholder vacío
      $(this.$refs.oficiosSelect).append(
        $('<option>', { value: '', text: 'Seleccionar oficio' })
      );

      

      // Recorre los oficios y los agrega
      oficios?.forEach(p => {
        let pendingQty = p?.pending_quantity;

        if (pendingQty === undefined || pendingQty === null) {
          if (this.production_user.production_models_id != 0) {
            const modelo = this.models.find(h => parseInt(h.id) == parseInt(this.production_user.production_models_id));
            pendingQty = modelo ? (parseFloat(modelo.quantity_to_produce) || 0) : 0;
          } else {
            let total = 0;
            this.models.forEach(m => {
              total += parseFloat(m.quantity_to_produce) || 0;
            });
            pendingQty = total;
          }
        }

        const optionText = `${p?.name} - Pendiente: ${pendingQty}`;

        $(this.$refs.oficiosSelect).append(
          $('<option>', { value: p.id, text: optionText }).attr('data-quantity', pendingQty)
        );
      });


      $(this.$refs.oficiosSelect).select2({
        placeholder: 'Seleccione un oficio',
        allowClear: false,
        dropdownParent: $('#ModalBudget .modal-body'),
      }).on('change', () => {
        this.production_user.oficio_id = $(this.$refs.oficiosSelect).val();
        
        this.$nextTick(() => {
          // Establecer la cantidad asignada considerando tanto el modelo como el oficio
          // Usar maxQuantityAllowed que ya calcula el mínimo entre ambos
          const maxAllowed = this.maxQuantityAllowed;
          
          if (maxAllowed > 0) {
            this.production_user.received_quantity = maxAllowed;
          } else {
            // Si no hay máximo permitido, intentar usar la cantidad pendiente del oficio
            const selectedOption = $(this.$refs.oficiosSelect).find('option:selected');
            const pendingQuantity = selectedOption.data('quantity');
            
            if (pendingQuantity) {
              this.production_user.received_quantity = parseFloat(pendingQuantity) || 0;
            }
          }
          
          // Validar la cantidad después de cambiar el oficio
          this.validateQuantity();
        });
        
        this.filterUsersByOficio();
      });

    },
    async getUsers() {
      this.users = await this.$store.dispatch('users/getAll', 'all');

      $(this.$refs.userSelect).select2({
        placeholder: 'Seleccione un usuario',
        allowClear: false,
        dropdownParent: $('#ModalEditStaff .modal-body')
      });

      $(this.$refs.userSelect).on('change', () => {
        this.production_user.user_id = $(this.$refs.userSelect).val();
      });
    },
    async filterUsersByOficio() {
      if (this.production_user.oficio_id != 0) {
        this.filteredUsers = this.users.filter(user => {
          // Asegúrate de que processes sea un arreglo
          const processes = Array.isArray(user.processes)
            ? user.processes
            : JSON.parse(user.processes || "[]");
          return processes.map(Number).includes(Number(this.production_user.oficio_id));
        });
      } else {
        this.filteredUsers = []; // Mostrar todos los usuarios si no hay oficio seleccionado
      }


       // Limpia el select antes de cargar
      $(this.$refs.usersSelect).empty();

      // Agrega placeholder vacío
      $(this.$refs.usersSelect).append(
        $('<option>', { value: '', text: 'Seleccionar usuario' })
      );

      // Recorre las producciones y las agrega
      this.filteredUsers?.forEach(p => {
        $(this.$refs.usersSelect).append(
          $('<option>', { value: p.id, text:  p.name }).attr('data-payment', p?.payment) 
        );
      });


      $(this.$refs.usersSelect).select2({
        placeholder: 'Seleccionar usuario',
        allowClear: false,
        dropdownParent: $('#ModalBudget .modal-body'),
      }).on('change', async () => {
        this.production_user.user_id = $(this.$refs.usersSelect).val();

        this.fieldPayment = true;

        // Consultar la última tarea asignada del usuario
        // El controlador ya ordena por assigned_at desc, así que el primer elemento será la última asignación
        const params = new URLSearchParams({
          user_id: this.production_user.user_id
        });
        
        try {
          // El store getAll retorna directamente response.data.data ?? []
          const producciones = await this.$store.dispatch('productionUsers/getAll', params);
          
          // Actualizar el texto del label con la última asignación
          if (producciones && producciones.length > 0) {
            const ultimaAsignacion = producciones[0]; // Ya está ordenado por assigned_at desc en el controlador
            const fechaAsignacion = ultimaAsignacion.assigned_at 
              ? new Date(ultimaAsignacion.assigned_at).toLocaleDateString('es-ES')
              : 'Sin fecha';
            
            const nombreProduccion = ultimaAsignacion.production?.name || `Producción #${ultimaAsignacion.production?.id || 'N/A'}`;
            $('#mensajeAsignacion').text(`Producción: ${nombreProduccion} (${fechaAsignacion})`);
          } else {
            $('#mensajeAsignacion').text('Sin asignar');
          }
        } catch (error) {
          console.error('Error al consultar última asignación:', error);
          $('#mensajeAsignacion').text('Sin asignar');
        }

      });
    },
    async openValidarTareaFromModal() {
      const tasksValidated = Array.isArray(this.data)
        ? this.data.filter(item => item.validated_date != null)
        : [];
      if (tasksValidated.length === 0) {
        await Swal.fire({
          icon: 'info',
          title: 'Sin tareas',
          text: 'No hay tareas validadas en esta página para sumar defectuosos.',
        });
        return;
      }
      const optionsHtml = tasksValidated.map((t) => {
        const label = `${t.user?.name || 'N/A'} - ${t.production?.name || 'N/A'} - ${t.model?.model?.name || 'N/A'} (Defectuosos: ${t.rejected_quantity})`;
        return `<option value="${t.id}">${label}</option>`;
      }).join('');
      const { value: selectedId } = await Swal.fire({
        title: 'Asignar arreglos',
        html: `
          <div class="mb-3 text-start">
            <label for="swal-select-task-validate" class="form-label">Seleccione la tarea (ya validada):</label>
            <select id="swal-select-task-validate" class="form-select">${optionsHtml}</select>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        preConfirm: () => document.getElementById('swal-select-task-validate').value,
      });
      if (selectedId) {
        const task = tasksValidated.find(t => t.id == selectedId) || this.data.find(t => t.id == selectedId);
        if (task) {
          this.addDefectuososAndCreateTask(task);
        }
      }
    },
    async openModal() {
      this.production_user.assigned_at = new Date().toISOString().slice(0, 10);
      this.fieldPayment = true;

      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement);
      this.modalBudget.show();

      // Cargar producciones después de mostrar el modal para evitar demora
      if (this.productions.length === 0) {
        await this.getProductions();
      }
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
      this.markAsReceived = false;
    },
    async submitForm() {
      try {

        // Buscar el usuario seleccionado
        const user = this.users.find(h => h.id == this.production_user.user_id);

        // Validar fechas repetidas antes de enviar al backend
        if (user && Array.isArray(user.production_users)) {
          const existeFecha = user.production_users.some(pu => {
            // Convertimos ambas fechas al formato YYYY-MM-DD para comparar solo la parte de la fecha
            const fechaNueva = new Date(this.production_user.assigned_at).toISOString().split('T')[0];
            const fechaExistente = new Date(pu.assigned_at).toISOString().split('T')[0];
            return fechaNueva === fechaExistente;
          });

          if (existeFecha) {
            await Swal.fire({
              icon: 'warning',
              title: 'Fecha duplicada',
              text: 'El usuario ya tiene una asignación en esa fecha.',
            });
            return; // Cortar la ejecución y no guardar
          }
        }
        if (this.markAsReceived) {
          this.production_user.received_date = new Date().toISOString().slice(0, 10);
        } else {
          this.production_user.received_date = null;
        }
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("productionUsers/save", this.production_user);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.fetchData();
              this.closeModal();

              this.production_user.production_models_id = 0;
              this.production_user.oficio_id = 0;
              this.production_user.user_id = 0;
              this.production_user.received_quantity = 0;
              this.production_user.price = 0;
              this.production_user.benefit = 0;
              this.production_user.delivered_quantity = 0;
              this.production_user.received_date = null;
              this.markAsReceived = false;

              $(this.$refs.productionSelect).val(null).trigger('change');
              $(this.$refs.modelSelect).val(null).trigger('change');
              $(this.$refs.oficiosSelect).val(null).trigger('change');
              $(this.$refs.usersSelect).val(null).trigger('change');
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    async checkReceived(value) {

      try {
        const result = await Swal.fire({
          title: 'Recibir Tarea',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'sí, aceptar',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {

          value.received_date = new Date().toISOString().slice(0, 10);

          const response = await this.$store.dispatch("productionUsers/save", value);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Tarea aceptada!',
              'Recuerda realizar la entrega.',
              'success'
            );

            this.fetchData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async handleDeliveredInput(value) {
      if (this.isSaving) return;
      const deliveredQty = Number(value.delivered_quantity);
      const receivedQty = Number(value.received_quantity);

      if (isNaN(deliveredQty) || deliveredQty <= 0) {
        return;
      }

      if (deliveredQty > receivedQty) {
        await Swal.fire({
          icon: 'warning',
          title: 'Cantidad excedida',
          text: 'La cantidad entregada no puede ser mayor a la recibida.',
        });
        return;
      }

      const { value: formValues } = await Swal.fire({
        title: 'Entregar Tarea',
        html: `
        <div style="text-align: left;">
          <div class="mb-3">
            <label class="form-label" style="font-weight: bold;">Cantidad entregada: ${deliveredQty}</label>
          </div>
          <div class="mb-3">
            <label for="swal-input-obs-deliver" class="form-label" style="font-weight: bold;">Observación:</label>
            <textarea id="swal-input-obs-deliver" class="form-control" placeholder="Agregue una observación" rows="3"></textarea>
          </div>
        </div>`,
        focusConfirm: false,
        preConfirm: () => {
          const obs = document.getElementById('swal-input-obs-deliver').value;
          return { obs };
        },
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'sí, aceptar',
        cancelButtonText: 'Cancelar',
      });

      if (!formValues) return;

      this.isSaving = true;
      const updatedValue = { ...value };
      updatedValue.delivered_date = new Date().toISOString().slice(0, 10);
      updatedValue.delivered_quantity = deliveredQty;
      updatedValue.observation = formValues.obs;

      try {
        const response = await this.$store.dispatch("productionUsers/save", updatedValue);

        if (response && response.status >= 200 && response.status < 300) {
          if (deliveredQty < receivedQty) {
            const remaining = receivedQty - deliveredQty;
            await this.checkValidated(updatedValue, remaining);
          } else {
            await Swal.fire('Tarea Entregada!', 'Excelente trabajo.', 'success');
            this.fetchData();
          }
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      } finally {
        this.isSaving = false;
      }
    },
    async checkDelivered(value) {

      const updatedValue = { ...value };

      try {

        let cantt = Number(updatedValue.received_quantity) - Number(updatedValue.delivered_quantity);


        const { value: formValues } = await Swal.fire({
          title: 'Entregar Tarea',
          html: `
          <div style="text-align: left;">
          <div class="mb-3">
                <label for="swal-input-cant" class="form-label" style="font-weight: bold;">Si entregas una cantidad menor a la recibida, tendreas que volver a realizar la entrega del restante</label>
              </div>
              <div class="mb-3" hidden>
                <label for="swal-input-cant" class="form-label" style="font-weight: bold;">Cantidad entregada:</label>
                <input id="swal-input-cant" type="number" class="form-control" placeholder="Cantidad entregada" min="1" value="${cantt}">
              </div>
              <div class="mb-3">
                <label for="swal-input-obs" class="form-label" style="font-weight: bold;">Observación:</label>
                <textarea id="swal-input-obs" class="form-control" placeholder="Agregue una observación" rows="3"></textarea>
              </div>
            </div>`,
          focusConfirm: false,
          preConfirm: () => {
            const cant = document.getElementById('swal-input-cant').value;
            const obs = document.getElementById('swal-input-obs').value;


            return { cant: parseInt(cant, 10), obs };
          },
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'sí, aceptar',
          cancelButtonText: 'Cancelar',
        });

        if (formValues) {
          updatedValue.delivered_date = new Date().toISOString().slice(0, 10);
          updatedValue.delivered_quantity = formValues.cant;
          updatedValue.observation = formValues.obs;

          const response = await this.$store.dispatch("productionUsers/save", updatedValue);

          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire(
              'Tarea Entregada!',
              'Excelente trabajo.',
              'success'
            );
            this.fetchData();
          } else {
            throw new Error(response.data.message || 'Error al guardar el registro');
          }
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);


        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });



      }
    },
  async checkValidated(value, prefilledDefects = null) {
  try {
    // Asegurarse de que oficios esté cargado
    if (!this.oficios || this.oficios.length === 0) {
      await this.getOficiosList();
    }

    const { value: formValues } = await Swal.fire({
      title: 'Validar Tarea',
      html: `
        <div style="text-align: left;">
          <!-- Defectos -->
          <div class="mb-3">
            <label for="swal-input-defect" class="form-label" style="font-weight: bold;">Cantidad con defectos (Imperfectos):</label>
            <input id="swal-input-defect" type="number" class="form-control" placeholder="Cantidad con defectos" min="0" value="${prefilledDefects !== null ? prefilledDefects : ''}">
          </div>

          <!-- Campos para nueva tarea cuando hay imperfectos (se muestran cuando hay imperfectos) -->
          <div id="swal-nueva-tarea-section" style="display:none;">
            <div class="mb-3">
              <label for="swal-select-oficio-nueva" class="form-label" style="font-weight: bold;">Oficio para nueva tarea:</label>
              <select id="swal-select-oficio-nueva" class="form-control">
                <option value="">Seleccionar oficio</option>
                ${this.oficios.map(o => `<option value="${o.id}">${o.name}</option>`).join("")}
              </select>
            </div>
            <div class="mb-3">
              <label for="swal-user-nueva" class="form-label" style="font-weight: bold;">Seleccionar usuario de tarea:</label>
              <select id="swal-user-nueva" class="form-control">
                <option value="">Seleccionar usuario</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="swal-observacion-nueva" class="form-label" style="font-weight: bold;">Observación:</label>
              <textarea id="swal-observacion-nueva" class="form-control" rows="3" placeholder="Agregar observación"></textarea>
            </div>
          </div>

        </div>
      `,
      didOpen: () => {
        const defectInput = document.getElementById('swal-input-defect');
        const nuevaTareaSection = document.getElementById('swal-nueva-tarea-section');
        const popup = Swal.getPopup();
        const oficioSelect = document.getElementById('swal-select-oficio-nueva');
        const userSelect = document.getElementById('swal-user-nueva');

        // Si viene con defectos pre-llenados (entrega parcial), mostrar sección nueva tarea
        if (prefilledDefects !== null && prefilledDefects > 0) {
          defectInput.value = String(prefilledDefects);
          defectInput.readOnly = true;
          nuevaTareaSection.style.display = 'block';
        }

        // Autoseleccionar el oficio del registro actual en "Oficio para nueva tarea"
        const currentOficioId = value?.oficio_id ?? value?.oficio?.id ?? '';
        if (oficioSelect && currentOficioId) {
          oficioSelect.value = String(currentOficioId);

          // Fallback por nombre si el ID no coincide exactamente con las opciones cargadas
          if (!oficioSelect.value && value?.oficio?.name) {
            const matchedOficio = this.oficios.find(
              (item) => String(item?.name || '').trim().toLowerCase() === String(value.oficio.name).trim().toLowerCase()
            );
            if (matchedOficio?.id) {
              oficioSelect.value = String(matchedOficio.id);
            }
          }
        }

        const getUsersByOficio = (oficioId) => {
          if (!oficioId) return [];
          return this.users.filter((user) => {
            try {
              const processes = Array.isArray(user.processes)
                ? user.processes
                : JSON.parse(user.processes || '[]');
              return processes.map(Number).includes(Number(oficioId));
            } catch (error) {
              return false;
            }
          });
        };

        const renderUsersByOficio = (oficioId) => {
          if (!userSelect) return;

          const usersByOficio = getUsersByOficio(oficioId);
          userSelect.innerHTML = `
            <option value="">Seleccionar usuario</option>
            ${usersByOficio.map((u) => `<option value="${u.id}">${u.name}</option>`).join('')}
          `;

          if ($('#swal-user-nueva').hasClass('select2-hidden-accessible')) {
            $('#swal-user-nueva').off('change').select2('destroy');
          }

          $('#swal-user-nueva').select2({
            placeholder: 'Seleccionar usuario',
            allowClear: true,
            width: '100%',
            dropdownParent: $(popup),
          });
        };

        // Cargar usuarios filtrados según el oficio autoseleccionado
        renderUsersByOficio(oficioSelect?.value || '');

        // Cuando cambie el oficio, recargar usuarios permitidos
        if (oficioSelect) {
          oficioSelect.addEventListener('change', () => {
            renderUsersByOficio(oficioSelect.value || '');
          });
        }

        // Función para actualizar la visibilidad basada en imperfectos
        const updateVisibility = () => {
          const cant = Number(defectInput.value) || 0;
          
          if (cant > 0) {
            // Si hay imperfectos, mostrar campos de nueva tarea
            nuevaTareaSection.style.display = 'block';
          } else {
            // Si no hay imperfectos, ocultar campos de nueva tarea
            nuevaTareaSection.style.display = 'none';
          }
        };

        // Actualizar visibilidad cuando cambia la cantidad de imperfectos
        defectInput.addEventListener('input', updateVisibility);
      },
      focusConfirm: false,
      preConfirm: () => {
        const defectInput = document.getElementById('swal-input-defect').value;

        if (defectInput === '' || isNaN(defectInput)) {
          Swal.showValidationMessage('Debe ingresar una cantidad válida de defectos.');
          return false;
        }
        const cant = Number(defectInput);
        if (cant > Number(value.received_quantity)) {
          Swal.showValidationMessage('La cantidad con defectos supera la asignada.');
          return false;
        }

        // Si hay imperfectos, validar y retornar datos de nueva tarea
        if (cant > 0) {
          const oficioNueva = document.getElementById('swal-select-oficio-nueva')?.value || '';
          const userNueva = document.getElementById('swal-user-nueva')?.value || '';
          const obsNueva = document.getElementById('swal-observacion-nueva')?.value || '';

          if (!oficioNueva) {
            Swal.showValidationMessage('Debe seleccionar un oficio para la nueva tarea.');
            return false;
          }
          if (!userNueva) {
            Swal.showValidationMessage('Debe seleccionar un usuario para la nueva tarea.');
            return false;
          }

          // Usar la cantidad de defectos como cantidad para la nueva tarea
          return {
            defectos: cant,
            selected_option: 'new_task',
            nueva_tarea: {
              oficio_id: parseInt(oficioNueva),
              user_id: parseInt(userNueva),
              cantidad: cant, // Usar la cantidad de defectos
              observacion: obsNueva.trim(),
            },
            oficio_id: parseInt(oficioNueva)
          };
        }

        // Si no hay imperfectos, solo retornar defectos
        return {
          defectos: cant,
          selected_option: null
        };
      },
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
    });

    if (formValues) {
      // CREAR NUEVA TAREA ANTES DE VALIDAR LA TAREA ACTUAL
      console.log('formValues:', formValues);
      console.log('formValues.nueva_tarea:', formValues.nueva_tarea);
      console.log('formValues.oficio_id:', formValues.oficio_id);
      
      // Manejar nueva tarea cuando hay imperfectos
      if (formValues.selected_option === 'new_task' && formValues.nueva_tarea) {
        try {
          // Fecha de asignación: fecha actual del día
          const today = new Date().toISOString().slice(0, 10);
          
          const newTask = {
            id: 0,
            production_id: value.production_id,
            production_models_id: value.production_models_id,
            oficio_id: formValues.nueva_tarea.oficio_id,
            user_id: formValues.nueva_tarea.user_id,
            received_quantity: formValues.nueva_tarea.cantidad,
            observation: formValues.nueva_tarea.observacion || `Tarea creada automáticamente desde defectuosos de tarea #${value.id}`,
            status: 0,
            assigned_at: today,
            check_defects: true,
          };
          
          console.log('Creando nueva tarea ANTES de validar:', newTask);
          const newTaskResponse = await this.$store.dispatch("productionUsers/save", newTask);
          console.log('Respuesta creación nueva tarea:', newTaskResponse);
          
          if (newTaskResponse && newTaskResponse.status >= 200 && newTaskResponse.status < 300) {
            console.log('Nueva tarea creada exitosamente');
          } else {
            console.error('Error al crear nueva tarea - respuesta:', newTaskResponse);
            throw new Error('Error al crear la nueva tarea');
          }
        } catch (error) {
          console.error("Error al crear nueva tarea:", error);
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error al crear la nueva tarea: ' + (error.message || 'Error desconocido') + '. La tarea no se validará.',
          });
          return; // No continuar con la validación si falla la creación de la nueva tarea
        }
      }

      // AHORA SÍ VALIDAR LA TAREA ACTUAL
      // Crear un nuevo objeto para evitar race conditions
      const updatedValue = {
        ...value,
        validated_date: new Date().toISOString().slice(0, 10),
        rejected_quantity: formValues.defectos,
        finish: 1,
        selected_option: formValues.selected_option, // 🔹 Ya viene en inglés
      };

      if (formValues.corte) {
        Object.assign(updatedValue, {
          corte_user_id: formValues.corte.user_id,
          corte_cantidad: formValues.corte.cantidad,
          laundry_observation: formValues.corte.observacion
        });
      }

      if (formValues.lavanderia) {
        Object.assign(updatedValue, {
          laundry_observation: formValues.lavanderia.observacion
        });
      }

      if (formValues.arreglos) {
        Object.assign(updatedValue, {
          arreglo_user_id: formValues.arreglos.user_id,
          arreglo_cantidad: formValues.arreglos.cantidad,
          laundry_observation: formValues.arreglos.observacion,
        });
      }

      const response = await this.$store.dispatch("productionUsers/save", updatedValue);
      if (response && response.status >= 200 && response.status < 300) {

        // Mensaje de éxito
        let successMessage = 'Excelente trabajo.';
        if (formValues.corte || formValues.arreglos) {
          if (formValues.oficio_id) {
            successMessage = 'Tarea validada y nueva tarea creada.';
          } else {
            successMessage = 'Tarea validada.';
          }
        } else if (formValues.lavanderia) {
          successMessage = 'Tarea validada. Observación de lavandería guardada.';
        }

        await Swal.fire('Tarea Validada!', successMessage, 'success');
        this.fetchData();
      } else {
        throw new Error(response.data.message || 'Error al guardar el registro');
      }
    }
  } catch (error) {
    console.error("Error al validar el registro:", error);
    await Swal.fire({
      icon: 'error',
      title: 'Error',
      text: error.message || 'Error al validar el registro',
    });
  }
},
    async addDefectuososAndCreateTask(value) {
      try {
        if (!this.oficios || this.oficios.length === 0) {
          await this.getOficiosList();
        }
        const currentRejected = Number(value.rejected_quantity) || 0;
        const received = Number(value.received_quantity) || 0;
        const maxNuevaCant = Math.max(0, received - currentRejected);

        const { value: formValues } = await Swal.fire({
          title: 'Asignar arreglos',
          html: `
            <div style="text-align: left;">
              <div class="mb-3">
                <label for="swal-input-defect-add" class="form-label" style="font-weight: bold;">Cantidad asignada a la nueva tarea (máx. recibida − defectuosos actuales = ${maxNuevaCant}):</label>
                <input id="swal-input-defect-add" type="number" class="form-control" placeholder="Máx. ${maxNuevaCant}" min="1" max="${maxNuevaCant}">
              </div>
              <div class="mb-3">
                <label for="swal-select-oficio-add" class="form-label" style="font-weight: bold;">Oficio para nueva tarea:</label>
                <select id="swal-select-oficio-add" class="form-control">
                  <option value="">Seleccionar oficio</option>
                  ${this.oficios.map(o => `<option value="${o.id}">${o.name}</option>`).join('')}
                </select>
              </div>
              <div class="mb-3">
                <label for="swal-user-add" class="form-label" style="font-weight: bold;">Usuario para nueva tarea:</label>
                <select id="swal-user-add" class="form-control">
                  <option value="">Seleccionar usuario</option>
                  ${this.users.map(u => `<option value="${u.id}">${u.name}</option>`).join('')}
                </select>
              </div>
              <div class="mb-3">
                <label for="swal-observacion-add" class="form-label" style="font-weight: bold;">Observación:</label>
                <textarea id="swal-observacion-add" class="form-control" rows="2" placeholder="Observación"></textarea>
              </div>
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: 'Crear tarea',
          cancelButtonText: 'Cancelar',
          preConfirm: () => {
            const input = document.getElementById('swal-input-defect-add');
            const oficioId = document.getElementById('swal-select-oficio-add')?.value || '';
            const userId = document.getElementById('swal-user-add')?.value || '';
            const cant = Number(input?.value) || 0;
            if (!cant || cant < 1) {
              Swal.showValidationMessage('Ingrese una cantidad válida.');
              return false;
            }
            if (cant > maxNuevaCant) {
              Swal.showValidationMessage('La cantidad asignada no puede superar la recibida menos los defectuosos actuales (' + maxNuevaCant + ').');
              return false;
            }
            if (!oficioId || !userId) {
              Swal.showValidationMessage('Seleccione oficio y usuario para la nueva tarea.');
              return false;
            }
            const obs = document.getElementById('swal-observacion-add')?.value || '';
            return { cant, oficio_id: parseInt(oficioId), user_id: parseInt(userId), observacion: obs };
          },
        });

        if (!formValues) return;

        const today = new Date().toISOString().slice(0, 10);
        const newTask = {
          id: 0,
          production_id: value.production_id,
          production_models_id: value.production_models_id,
          oficio_id: formValues.oficio_id,
          user_id: formValues.user_id,
          received_quantity: formValues.cant,
          observation: formValues.observacion.trim() || `Tarea creada desde defectuosos adicionales de tarea #${value.id}`,
          assigned_at: today,
        };
        const newTaskResponse = await this.$store.dispatch('productionUsers/save', newTask);
        if (!newTaskResponse || newTaskResponse.status < 200 || newTaskResponse.status >= 300) {
          throw new Error('Error al crear la nueva tarea');
        }

        const updatedValue = {
          id: value.id,
          rejected_quantity: currentRejected + formValues.cant,
        };
        const updateResponse = await this.$store.dispatch('productionUsers/save', updatedValue);
        if (updateResponse && updateResponse.status >= 200 && updateResponse.status < 300) {
          await Swal.fire('Listo', 'Defectuosos sumados y nueva tarea creada.', 'success');
          this.fetchData();
        } else {
          throw new Error(updateResponse?.data?.message || 'Error al actualizar defectuosos');
        }
      } catch (error) {
        console.error('Error en addDefectuososAndCreateTask:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al procesar.',
        });
      }
    },

    async checkValidatedOld(value) {
      try {
        const { value: defectInput } = await Swal.fire({
          title: 'Validar Tarea',
          html: `
        <div style="text-align: left;">
          <div class="mb-3">
            <label for="swal-input-defect" class="form-label" style="font-weight: bold;">Cantidad con defectos:</label>
            <input id="swal-input-defect" type="number" class="form-control" placeholder="Cantidad con defectos" min="0">
          </div>
        </div>
      `,
          focusConfirm: false,
          preConfirm: () => {
            const defectInput = document.getElementById('swal-input-defect').value;

            // Validar la entrada del usuario
            if (defectInput === '' || isNaN(defectInput)) {
              Swal.showValidationMessage('Debe ingresar una cantidad válida.');
              return false;
            }

            // Convertir defectInput a número
            const cant = Number(defectInput);

            // Validar que la cantidad no supere la cantidad recibida
            if (cant > Number(value.received_quantity)) {
              Swal.showValidationMessage('La cantidad supera la asignada.');
              return false; // Cambiar a false para evitar el cierre del modal
            }

            return cant; // Retornar la cantidad válida
          },
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
        });

        // Aquí se usa defectInput en lugar de cant
        if (defectInput !== undefined) { // Verifica que defectInput no sea undefined
          value.validated_date = new Date().toISOString().slice(0, 10);
          value.rejected_quantity = defectInput; // Usar defectInput
          value.finish = 1;

          const response = await this.$store.dispatch("productionUsers/save", value);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire(
              'Tarea Validada!',
              'Excelente trabajo.',
              'success'
            );

            this.fetchData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async deleteUserRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionUsers/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.fetchData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    isValidDate(date) {
      if (!date) {
        return false;
      }
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    },
    formatDate(dateString) {
      if(dateString==''){return ''}
      const parts = dateString.split('-'); // Divide la fecha en partes
      return `${parts[2]}/${parts[1]}/${parts[0]}`; // Reorganiza a dd/mm/yyyy
    },
    handleSearchInput() {
      // Cancelar el timeout anterior si existe
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      // Cancelar la petición anterior si existe
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel('Nueva búsqueda realizada');
      }

      // Crear un nuevo debounce
      this.searchTimeout = setTimeout(() => {
        this.fetchData(null, true);
      }, 500); // Esperar 500ms después de que el usuario deje de escribir
    },
    async fetchData(pageUrl = null, isSearch = false) {
      // Cancelar petición anterior solo si es una búsqueda nueva
      if (isSearch && this.cancelTokenSource) {
        this.cancelTokenSource.cancel('Nueva búsqueda realizada');
      }

      // Crear un nuevo CancelToken solo si es una búsqueda
      let cancelToken = null;
      if (isSearch) {
        const CancelToken = axios.CancelToken;
        this.cancelTokenSource = CancelToken.source();
        cancelToken = this.cancelTokenSource.token;
      }

      if (pageUrl !== null) {
        const pageParam = new URL(pageUrl, window.location.origin).searchParams.get("page");
        this.page = pageParam ? parseInt(pageParam) : 1;
      } else {
        // Si pageUrl es nulo, mantiene la página actual o usa 1 por defecto
        this.page = this.page || 1;
      }
    

      const filterPayment = this.filterPayment;
      
      const params = {
        search: this.searchQuery || '',
        start_date: this.startDate || '',
        end_date: this.endDate || '',
        production: this.selectedProductionFilter || '',
        oficio: this.filterOficioModal || '',
        payment: filterPayment !== '' ? filterPayment : '',
        filter_status: this.filterStatus || '',
        page: this.page,
      };

      await this.$store.dispatch('productionUsers/fetchData', {
        pageUrl: params,
        cancelToken: cancelToken
      });
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("production/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.fetchData(null);

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el usuario');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async loadSettings() {
      try {
        const response = await this.$store.dispatch("settings/get");
        if (response && response.data) {
          this.benefitsOfTasks = response.data.benefits_of_tasks || false;
        }
      } catch (error) {
        console.error("Error al cargar la configuración:", error);
      }
    },

  },
  async mounted() {
    // Cargar datos en paralelo para optimizar el tiempo de carga
    await Promise.all([
      this.fetchData(null), // Cargar la tabla principal primero
      this.getProductionFilterList(), // Cargar opciones de producción para filtro
      this.getOficiosList(), // Cargar oficios en paralelo
      this.getUsers(), // Cargar usuarios en paralelo
      this.loadSettings(), // Cargar configuración de beneficios
    ]);

    this.$nextTick(() => {
      this.initProductionFilterSelect2();
    });
    
    // Las producciones solo se necesitan cuando se abre el modal, 
    // así que se cargan cuando sea necesario
    // this.getProductions(); // Se carga cuando se abre el modal
  },
  beforeUnmount() {
    // Limpiar el timeout de búsqueda si existe
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    
    // Cancelar cualquier petición pendiente
    if (this.cancelTokenSource) {
      this.cancelTokenSource.cancel('Componente destruido');
    }

    if (this.$refs.filterProduction && $(this.$refs.filterProduction).hasClass('select2-hidden-accessible')) {
      $(this.$refs.filterProduction).off('change').select2('destroy');
    }
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}

.operation-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: flex-end;
  align-items: center;
}

.operation-action-btn {
  min-width: 170px;
  white-space: nowrap;
}

/* Móvil / tablet estrecha: un botón debajo del otro, ancho completo */
@media (max-width: 767.98px) {
  .operation-actions {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
  }

  .operation-action-btn {
    min-width: 0;
    width: 100%;
  }
}
</style>